import { GRAPH_DURATIONS, LIVE_CHART } from "constants/chartConstant";
import { AnalyticsStrings, CIPAnalyticsIndexTableStrings } from "constants/constantStrings";

export const CIP_INDEX_GRAPH_TYPE_DEFAULT = "table";
export const ANAYTICS_CHART_DURATIONS = (() => {
  const { [LIVE_CHART]: liveChart, "Past 1 hour": past1Hour, "Past 12 hours": past12Hours, ...newGraphDurations } = GRAPH_DURATIONS;
  return newGraphDurations;
})({ ...GRAPH_DURATIONS });

export const NormalizedTags = {
  normalized_differential_pressure: AnalyticsStrings.Normalized_DP,
  normalized_permeate_flow: AnalyticsStrings.Normalized_PF,
  normalized_salt_passage: AnalyticsStrings.Normalized_SP
};

export const CIPCleaningViews = {
  markers: AnalyticsStrings.CIP_Cleaning_Scatter_Chart,
  bar: AnalyticsStrings.CIP_Cleaning_Bar_Chart,
  table: AnalyticsStrings.CIP_Cleaning_Index_Table
};

export const CIPCleaningIndexes = {
  normalized_differential_pressure_Cleanability_Initial: CIPAnalyticsIndexTableStrings.DP_Cleanability_Initial,
  normalized_permeate_flow_Cleanability_Initial: CIPAnalyticsIndexTableStrings.PF_Cleanability_Initial,
  normalized_salt_passage_Cleanability_Initial: CIPAnalyticsIndexTableStrings.SP_Cleanability_Initial
};

export const AnalyticsTags = [
  {
    TagId: "normalized_permeate_flow",
    Color: "#00a9e0"
  },
  {
    TagId: "normalized_differential_pressure",
    Color: "#128370"
  },
  {
    TagId: "normalized_salt_passage",
    Color: "#fc2d72"
  }
];
